import * as auth from './auth';
import * as comm from './comm';
import * as cases from './cases';
import * as client from './client';
import * as upload from './upload';
import * as bitwerx from './bitwerx';
import * as greeting from './greeting';
import * as hospital from './hospital';
import * as payments from './payments';
import * as analytics from './analytics';
import * as onTheWay from './on-the-way';
import * as videoCall from './video-call';
import * as activation from './activation';
import * as voicemails from './voicemails';
import * as gvMessages from './gv-messages';
import * as videoCalls from './video-calls';
import * as urgentCare from './urgent-care';
import * as subscribers from './subscribers';
import * as actionItems from './action-items';
import * as subcription from './subscription';
import * as hospitalsReport from './hospitals';
import * as appointments from './appointments';
import * as googleAuthToken from './google-auth';
import * as hospitalTasks from './hospital-tasks';
import * as internalTasks from './internal-tasks';
import * as masterBitwerx from './masters-bitwerx';
import * as masterVetspire from './masters-vetspire';
import * as hospitalBitwerx from './hospital-bitwerx';
import * as customerFeedback from './customer-feedback';
import * as hospitalServices from './hospital-services';
import * as hospitalDashboard from './hospital-dashboard';

export const api = {
  auth,
  comm,
  cases,
  client,
  upload,
  bitwerx,
  greeting,
  hospital,
  payments,
  onTheWay,
  videoCall,
  analytics,
  activation,
  gvMessages,
  voicemails,
  videoCalls,
  urgentCare,
  actionItems,
  subcription,
  subscribers,
  appointments,
  hospitalTasks,
  internalTasks,
  masterBitwerx,
  masterVetspire,
  hospitalsReport,
  googleAuthToken,
  hospitalBitwerx,
  hospitalServices,
  customerFeedback,
  hospitalDashboard,
};
